import React from "react";
import { Schedule } from "./Schedule.js";
import { ToDo } from "./Todo.js";

export function HomePage(props) {
    return (
        <div>
            <ToDo uid={props.uid} setAlertMessage={props.setAlertMessage}/>
            <Schedule uid={props.uid}/>
        </div>
    );
}